<div class="public-page-container">
  <div *ngIf="isLoading">
    <div class="loading">
      <p-progressSpinner></p-progressSpinner>
    </div>
  </div>

  <!-- Logo -->
  <div class="logo-container">
    <img [src]="logoUrl" alt="Client Logo" class="client-logo" />
  </div>

  <!-- Download File UI -->
  <div class="download-file-container" *ngIf="downloadFileText.length">
    <div class="download-spinner">
      <p-progressSpinner [style]="{ width: '20px', height: '20px' }" strokeWidth="8" fill="#EEEEEE"
        animationDuration="2s"></p-progressSpinner>
    </div>
    <div class="download-text">
      <span>{{ downloadFileText }}</span>
    </div>
  </div>


  <!-- Header -->
  <div class="header-container">
    <h1 class="page-title">
      {{ currentType === 'CAMPAIGN' ? 'Campaign' : 'Plan' }} Tracker
    </h1>
  </div>

  <!-- Content Area -->
  <div class="content-grid">

    <!-- Client Info -->
    <div class="client-info">
      <div class="font-18">{{ displayName }}</div>
      <div class="font-14">
        {{ billingName }}<br />
        {{ from }}{{ currentType === 'CAMPAIGN' ? (campaign.campaignStartDate | date:'ddMMMyy') :
        (plan.campaignStartDate | date:'ddMMMyy') }}<br />
        {{ to }}{{ currentType === 'CAMPAIGN' ? (campaign.campaignEndDate | date:'ddMMMyy') : (plan.campaignEndDate |
        date:'ddMMMyy') }}
      </div>
    </div>

    <!-- Input & Map -->
    <div class="input-map">
      <div class="input-wrapper">
        <input type="text" class="input-field" pInputText [(ngModel)]="searchTerm" placeholder="Search"
          (keyup)="searchInGrid()" pTooltip="{{ getCommaSeparatedFields() }}" />
      </div>
      <div class="map-button-wrapper">
        <a target="_blank" class="map-button"
          [routerLink]="currentType=='CAMPAIGN' ? ['../../../plans/public/view/map/' + campaignId + '/' + x_tenant,  { campaignTracker: true } ] : ['../../../../plans/public/view/map/' + planId + '/' + x_tenant,  { planTracker: true } ]">
          <i class="fa fa-map-marker map-icon"></i> View Map
        </a>
      </div>
    </div>
    <!-- Campaign Status (Only for Campaign Type and First Tab) -->
    <div class="legend-container" *ngIf="tabIndex === 0 && currentType === 'CAMPAIGN'">
      <div class="legend-item">
        <span class="legend-color approved"></span> Approved
      </div>
      <div class="legend-item">
        <span class="legend-color mounted"></span> Mounted
      </div>
      <div class="legend-item">
        <span class="legend-color expired"></span> Expired
      </div>
      <div class="legend-item">
        <span class="legend-color pending-approve"></span> Pending Approve
      </div>
    </div>





  </div>


  <!-- Responsive Grid Wrapper -->
  <div class="grid-wrapper">
    <div class="grid-actions">
      <div class="left-actions">

      </div>
      <div class="right-actions">
        <!-- Export Button -->

        <p-tieredMenu id="exportMenu" #exportMenu popup="popup" [model]="exportItem" appendTo="body"
          [style]="{ fontSize: '14px' }"></p-tieredMenu>
        <button pButton class="btn-compact with-icon" (click)="exportMenu.toggle($event)" label="Export"
          icon="fa fa-download" iconPos="right" title="Export"></button>


        <!-- View Photos Button -->
        <button *ngIf="tabIndex > 0" pButton class="btn-compact with-icon" label="View Photos" icon="fa fa-image"
          iconPos="right" (click)="viewImages()"></button>
      </div>
    </div>


    <div class="tabview-wrapper">
      <ng-template [ngIf]="currentType === 'CAMPAIGN'">
        <p-tabView [activeIndex]="tabIndex" (onChange)="onTabChange($event)">
          <p-tabPanel header="Home ({{ campaign.totalItems }})">
            <sib-totalsites [items]="campaignItems" (eEmitTotalItems)="setCampaignItemsLength($event)"
              (eEmitImages)="viewPhotos($event)"></sib-totalsites>
          </p-tabPanel>
          <p-tabPanel header="Mounting ({{ campaign.totalMountedItems }}/{{ campaign.totalMountItems }})">
            <sib-mountedsites [campaignMountingItems]="campaignMountingItems"
              (eEmitTotalMountingItems)="setCampaignMountingItems($event)"
              (eEmitImages)="viewPhotos($event)"></sib-mountedsites>
          </p-tabPanel>
          <p-tabPanel header="Monitoring ({{ campaign.totalMonitoredItems }}/{{ campaign.totalMonitoringItems }})">
            <sib-monitoringsites [campaignMonitoringItems]="campaignMonitoringItems"
              (eEmitTotalMonitoringItems)="setCampaignMonitoringItems($event)"
              (eEmitImages)="viewPhotos($event)"></sib-monitoringsites>
          </p-tabPanel>
          <p-tabPanel header="Unmounting ({{ campaign.totalUnmountedItems }}/{{ campaign.totalUnmountingItems }})">
            <sib-unmountingsites [campaignUnmountingItems]="campaignUnmountingItems"
              (eEmitTotalUnmountingItems)="setCampaignUnmountingItems($event)"
              (eEmitImages)="viewPhotos($event)"></sib-unmountingsites>
          </p-tabPanel>
        </p-tabView>
      </ng-template>

      <ng-template [ngIf]="currentType === 'PLAN'">
        <p-tabView [activeIndex]="tabIndex" (onChange)="onTabChange($event)">
          <p-tabPanel header="Sites ({{ plan.totalItems }})">
            <sib-totalsites [source]="'PLAN'" [items]="planItems" (eEmitTotalItems)="setPlanItemsLength($event)"
              (eEmitImages)="viewPhotos($event)"></sib-totalsites>

            <!-- <div class="card-table" *ngIf="isMobile">
            <div class="data-card" *ngFor="let item of planItems">
              <div><strong>HID:</strong> {{ item.inventory.customId }}</div>
              <div><strong>District:</strong> {{ item.inventory.district }}</div>
              <div><strong>City:</strong> {{ item.inventory.city }}</div>
              <div><strong>Area:</strong> {{ item.inventory.areaName }}</div>
              <div><strong>Location:</strong> {{ item.inventory.location }}</div>
            </div>
          </div> -->
          </p-tabPanel>
        </p-tabView>
      </ng-template>
    </div>
  </div>
</div>


<p-dialog header="No Images" [(visible)]="displayNoImageDialog" [modal]="true" [width]="370" [height]="170"
  (onHide)="displayNoImageDialog = false">
  There are no images in the {{displaySlideshowText}}.
  <div class="ctext-center padding-top-10">
    <button (click)="displayNoImageDialog = false" class="mtab-primary btn-confirm" label="OK" pButton></button>
  </div>
</p-dialog>


<!-- Dialog for PPT imagetype multiselection and then download the PPT -->
<p-dialog header="Download PPT" *ngIf="displayPPTdialog" [(visible)]="displayPPTdialog" [modal]="true"
  [responsive]="true" [autoAlign]="false" [minWidth]="300" [width]="330" (onHide)="hidePPTDialog()"
  [blockScroll]="true">
  <div class="ui-g-12">
    <p-multiSelect *ngIf="displayPPTdialog" [options]="imageTypeOptions" name="name" [(ngModel)]="selectedImageType"
      (onChange)="onFilterChange()" [style]="{'width': '100%'}" appendTo="body"
      [panelStyleClass]="'multiselect-drop-down'">
    </p-multiSelect>
  </div>
  <p-footer>
    <div style="text-align:center;">
      <button pButton class="mtab-primary margin-top-10" label="Download" (click)="downloadPPT()"
        [disabled]="!selectedImgType"></button>
    </div>
  </p-footer>
</p-dialog>

<div class="photo-dialog">
  <sib-photo-dialog (displayReset)="changePhotoDisplay($event)"></sib-photo-dialog>
</div>